import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService extends BaseService {

  constructor() {
    super();
  }
  // getRetailerContactDetails():Observable<any> {
  //   let url = APIUrl.retailerSalesReps
  //   return this.httpService.get(url)
  // }
  getSupportContactDetails(): Observable<any> {

    let url = APIUrl.contactSupport;
    
    return this.httpService.get(url);
    
    }
}
